import { render } from "./SyncFail.vue?vue&type=template&id=2b8ff577&scoped=true"
import script from "./SyncFail.vue?vue&type=script&lang=js"
export * from "./SyncFail.vue?vue&type=script&lang=js"

import "./SyncFail.vue?vue&type=style&index=0&id=2b8ff577&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8ff577"]])

export default __exports__